import React from 'react';
import { InternalCalculationContext } from './InternalCalculationContext';

const useInternalCalculationContext = () => React.useContext(InternalCalculationContext);

export { useInternalCalculationContext };
